var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29160",
    "data-name": "Group 29160",
    transform: "translate(14309.08 -11821.08) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2837",
    "data-name": "Rectangle 2837",
    width: 20,
    height: 20,
    transform: "translate(-11841.08 -14309.08)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    d: "M4,9l5.669,5.669L15.337,9",
    transform: "translate(-11840.917 -14310.58)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightA);
export default __webpack_public_path__ + "static/media/right_a.564dd5830c897a87a2951cc9d1e9f8a5.svg";
export { ForwardRef as ReactComponent };